"use client";

import { Tokens } from "~/services/api/types/tokens";
import { User } from "~/services/api/types/user";
import {
    createContext,
    type Dispatch,
    type RefObject,
    type SetStateAction,
} from "react";

export type TokensInfo = Tokens | null;

export const AuthContext = createContext<{
    user: User | null;
    isLoaded: boolean;
    isLoading: boolean;
}>({
    user: null,
    isLoaded: true,
    isLoading: true,
});

export const AuthActionsContext = createContext<{
    setUser: Dispatch<SetStateAction<User | null>>;
    logOut: () => Promise<void>;
        }>({
            setUser: () => {},
            logOut: async () => {},
        });

export const AuthTokensContext = createContext<{
    tokensInfoRef: RefObject<Tokens>;
    setTokensInfo: (tokensInfo: TokensInfo) => void;
        }>({
            tokensInfoRef: {
                current: {
                    token: null,
                    refreshToken: null,
                    tokenExpires: null,
                },
            },
            setTokensInfo: () => {},
        });
